/**
 * "Who are you?", asked once, before the board opens.
 *
 * The board labels every element with the hand that placed it. Without a name
 * the other side reads "Patient", which is true and useless — the point of
 * showing whose hand it was is that the therapist can say "you moved your
 * mother there", not "someone did".
 *
 * The same question the constellation board asks, for the same reason.
 */

import { useState } from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../../shared/ui/button/Button";
import { MAX_NAME_LENGTH } from "../../domain/types";

interface Props {
    onSubmit: (name: string) => void;
}

export default function NameGate({ onSubmit }: Props) {
    const { t } = useTranslation();
    const [name, setName] = useState("");
    const trimmed = name.trim();

    return (
        <div className="flex h-[100dvh] w-screen items-center justify-center bg-surface-base p-6">
            <form
                className="w-full max-w-sm rounded-2xl border border-border-subtle bg-surface-raised p-6"
                onSubmit={(event) => {
                    event.preventDefault();
                    if (trimmed) onSubmit(trimmed);
                }}
            >
                <img
                    src="/images/logo/icon.png"
                    alt="Alchely"
                    width={32}
                    height={32}
                    className="mb-4 rounded-md"
                />
                <h1 className="text-xl font-semibold text-content-primary">
                    {t("systemicMap.join.title")}
                </h1>
                <p className="mt-1 text-sm text-content-secondary">
                    {t("systemicMap.join.help")}
                </p>

                <label className="mt-5 block">
                    <span className="mb-1 block text-[13px] font-medium text-content-secondary">
                        {t("systemicMap.join.name")}
                    </span>
                    <input
                        type="text"
                        value={name}
                        autoFocus
                        maxLength={MAX_NAME_LENGTH}
                        placeholder={t("systemicMap.join.namePlaceholder")}
                        onChange={(event) => setName(event.target.value)}
                        className="min-h-11 w-full rounded-md border border-border-strong bg-surface-raised px-3 py-2 text-sm text-content-primary placeholder:text-content-tertiary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
                    />
                </label>

                <Button className="mt-4" type="submit" fullWidth disabled={!trimmed}>
                    {t("systemicMap.join.enter")}
                </Button>
            </form>
        </div>
    );
}
